import type { ReactNode } from 'react'
import { Button } from '@/components/Button'
import { ButtonCollection } from '@/components/ButtonCollection'
import styles from './Login.module.css'

export interface LoginViewProps {
  children: ReactNode
}

export function LoginView({ children }: LoginViewProps) {
  return (
    <div className={styles.root} data-test="LoginView">
      {children}
    </div>
  )
}

export interface LoginProps {
  logoPrimary: string
  workspaceName: string
  onLogin: () => unknown
  onSignUp: () => unknown
}

export function Login({
  logoPrimary,
  workspaceName,
  onLogin,
  onSignUp,
}: LoginProps) {
  return (
    <>
      <div className={styles.logo}>
        <img src={logoPrimary} alt="" />
      </div>
      <div className={styles.content}>
        <div className={styles.text}>
          <h3>Welcome to {workspaceName}</h3>
          <p>Please log in or sign up.</p>
        </div>
        <div>
          <ButtonCollection>
            <Button
              label="Log In"
              variant="primary"
              onPress={onLogin}
              testId="LoginButton"
            />
            <Button
              label="Sign Up"
              variant="secondary"
              onPress={onSignUp}
              testId="SignupButton"
            />
          </ButtonCollection>
        </div>
      </div>
    </>
  )
}
